import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot, Slottable } from '../slot';
import { carouselHeaderStyles } from './styles/carousel-header.styles';
import type { CarouselHeaderPropsInterface } from './types/carousel-header.types';

/**
 * @since 10.0.0
 */
export const CarouselHeader = forwardRef<HTMLDivElement, CarouselHeaderPropsInterface>(
  (props: CarouselHeaderPropsInterface, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;
    const styles = css(carouselHeaderStyles, cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Carousel.Header"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        <Slottable>{children}</Slottable>
      </Component>
    );
  },
);

CarouselHeader.displayName = 'Carousel.Header';
